import { createCrudDataModule } from '@perpay-web/data-module/createCrudDataModule';
import { CANCELED } from '@perpay-web/fintech/constants/featureEnrollmentStatuses';
import { getIsPerpayPlusVersion } from '@perpay-web/fintech/constants/featureTypes';
import { createFeatureEnrollmentForPerpayPlusDataModule } from '@perpay-web/fintech/dataModules/createFeatureEnrollmentForPerpayPlus';
import { fetchFeatureEnrollmentsForPerpayPlusDataModule } from '@perpay-web/fintech/dataModules/fetchFeatureEnrollmentsForPerpayPlus';

const FeatureEnrollmentsForPerpayPlusCrudDataModule = createCrudDataModule({
    create: createFeatureEnrollmentForPerpayPlusDataModule,
    read: fetchFeatureEnrollmentsForPerpayPlusDataModule,
});

const getRoot = (state) => state.dataModules.featureEnrollmentsForPerpayPlus;
export const featureEnrollmentsForPerpayPlusCrudDataModule =
    FeatureEnrollmentsForPerpayPlusCrudDataModule({ getRoot });

const getFeatureEnrollments = (state) => {
    const featureEnrollmentEntities =
        featureEnrollmentsForPerpayPlusCrudDataModule.getData(state);
    return Object.values(featureEnrollmentEntities);
};

const getPerpayPlusEnrollments = (state) => {
    const featureEnrollments = getFeatureEnrollments(state);
    const perpayPlusEnrollments = featureEnrollments.filter((enrollment) =>
        getIsPerpayPlusVersion(enrollment.feature),
    );
    return perpayPlusEnrollments;
};

const getPerpayPlusEnrollmentStatus = (state) => {
    const perpayPlusEnrollments = getPerpayPlusEnrollments(state);
    // no more than 1 PP+ enrollment expected
    const perpayPlusEnrollment = perpayPlusEnrollments[0];
    return perpayPlusEnrollment ? perpayPlusEnrollment.status : null;
};

export const getHasPerpayPlus = (state) => {
    const status = getPerpayPlusEnrollmentStatus(state);
    return (status && status !== CANCELED) || false;
};
